import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Search } from 'assets/images/search_icon.svg';
import Button from 'components/Buttons/Button';

interface FieldProps {
  colstart: number;
  colend: number;
  rowstart: number;
  rowend: number;
}

export const Container = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05);
  padding: 10px;
  border-radius: 10px;
  border-top-left-radius: 0;
  background: ${ColorPalette.HEX.White};
`;

export const Fields = styled.div`
  display: grid;
  grid-template-columns: repeat(32, 1fr) 58px;
  grid-auto-rows: 8px;
  column-gap: 8px;
  row-gap: 8px;
  width: 100%;
  margin: 0 auto;
`;

export const Field = styled.div<FieldProps>`
  grid-column-start: ${({ colstart }) => colstart};
  grid-column-end: ${({ colend }) => colend};
  grid-row-start: ${({ rowstart }) => rowstart};
  grid-row-end: ${({ rowend }) => rowend};
`;

export const SearchButton = styled(Button)`
  height: 56px;
  font-size: 16px;
  padding: 0;
  background: ${ColorPalette.HEX.PineTree3};
  &:disabled {
    opacity: 0.1;
  }
`;

interface IconProps {
  $size?: number;
}
export const Icon = styled.div<IconProps>`
  color: ${ColorPalette.HEX.PineTree};
  width: ${({ $size }) => ($size ? `${$size}px` : '21px')};
  height: ${({ $size }) => ($size ? `${$size}px` : '21px')};
`;

export const IconSearch = styled(Search)`
  width: 28px;
  height: 28px;
`;
